import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTextureGlyphSecondary from './svgs/TextureGlyphSecondary.js';
import SvgTextureGlyph from './svgs/TextureGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var textureGlyph = (props => useIcon(SvgTextureGlyph, SvgTextureGlyphSecondary, props));

export { textureGlyph as default };
